import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button } from 'primereact/button';
import { FiSearch } from "react-icons/fi";

//NEW
import AuthContext from  "../../context/AuthContext";
import { GetBrandList } from 'services/other/brand.service';
import { GetVendorNameList } from 'services/vendor/vendor.service';
import { GetCategoryList } from 'services/other/category.service';
import { GetUnits } from 'services/user/user.service';
import { InputField } from "components/InputField/Input";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { ReportDownload } from 'services/report/report.service';
import { GetCPUList } from 'services/other/cpu.service';
import { GetGenList } from 'services/other/gen.service';
import { GetMemoryList } from 'services/other/memory.service';
import { GetHDDList } from 'services/other/hdd.service';
import { GetSSDList } from 'services/other/ssd.service';
import { GetColorList } from 'services/other/color.service';
import { GetGPUList } from 'services/other/gpu.service';
import { GetDisplayList } from 'services/other/display.service';
import { GetPermissions } from 'services/user/user.service';
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';

const Report = () => {

    const { reportList, reportListLoading } = useSelector((state) => state.reportList);
    const { vendorNameList } = useSelector((state) => state.vendorNameList);
    const { brandList } = useSelector((state) => state.brandList);
    const { categoryList } = useSelector((state) => state.categoryList);
    const { unitList } = useSelector((state) => state.units);

    const { cpuList } = useSelector((state) => state.cpuList);
    const { genList } = useSelector((state) => state.genList);
    const { memoryList } = useSelector((state) => state.memoryList);
    const { hddList } = useSelector((state) => state.hddList);
    const { ssdList } = useSelector((state) => state.ssdList);
    const { colorList } = useSelector((state) => state.colorList);
    const { gpuList } = useSelector((state) => state.gpuList);
    const { displayList } = useSelector((state) => state.displayList);

    const [autoVendorNameFilteredValue, setAutoVendorNameFilteredValue] = useState([]);
    const [autoBrandFilteredValue, setAutoBrandFilteredValue] = useState([]);
    const [autoCategoryFilteredValue, setAutoCategoryFilteredValue] = useState([]);
    const [autoUnitFilteredValue, setAutoUnitFilteredValue] = useState([]);

    const [autoCPUFilteredValue, setAutoCPUFilteredValue] = useState([]);
    const [autoGenFilteredValue, setAutoGenFilteredValue] = useState([]);
    const [autoMemoryFilteredValue, setAutoMemoryFilteredValue] = useState([]);
    const [autoHDDFilteredValue, setAutoHDDFilteredValue] = useState([]);
    const [autoSSDFilteredValue, setAutoSSDFilteredValue] = useState([]);
    const [autoColorFilteredValue, setAutoColorFilteredValue] = useState([]);
    const [autoGPUFilteredValue, setAutoGPUFilteredValue] = useState([]);
    const [autoDisplayFilteredValue, setAutoDisplayFilteredValue] = useState([]);

    const [date, setDate] =useState(new Date());

    const [showForm, setShowForm] = useState(false); //* state for form modal

    const [updateData, setUpdateData] = useState(null); // * state for update data

    // Get FrontEndPermission
    const { permissionList, permissionListLoading } = useSelector((state) => state.permissionList);
    const { user } = useContext(AuthContext);


    var fiveDaysAgo = new Date(date);
    fiveDaysAgo.setDate(date.getDate() - 7);

    const ref = useRef(null);
    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        start_purchase_date: null,
        end_purchase_date: null,
        unit: "",
        category: "",
        brand: "",
        vendor: '',
        cpu: "",
        gen: "",
        memory: "",
        hdd: "",
        ssd: "",
        color: "",
        gpu: "",
        display: "",
    };

    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        onSubmit: (values) => {
            const modified = {
                ...values,
                unit: parseInt(values?.unit?.id),
                category: parseInt(values?.category?.id),
                brand: parseInt(values?.brand?.id),
                vendor: parseInt(values?.vendor?.id),
                cpu: values?.cpu?.name || null,
                gen: values?.gen?.name || null,
                memory: values?.memory?.name || null,
                hdd: values?.hdd?.name || null,
                ssd: values?.ssd?.name || null,
                color: values?.color?.name || null,
                gpu: values?.gpu?.name || null,
                display: values?.display?.name || null,
            }
            handelSubmit(modified);
        },
        enableReinitialize: true,
    });

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();

    // form submit handler
    const handelSubmit = async (data) => {

        await dispatch(ReportDownload(data)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetUnits());
        dispatch(GetCategoryList());
        dispatch(GetVendorNameList());
        dispatch(GetBrandList());
            
        dispatch(GetCPUList());
        dispatch(GetGenList());
        dispatch(GetMemoryList());
        dispatch(GetHDDList());
        dispatch(GetSSDList());
        dispatch(GetColorList());
        dispatch(GetGPUList());
        dispatch(GetDisplayList());

    }, []);

    useEffect(() => {
        dispatch(GetPermissions());
    }, [user, ])

    const searchUnit = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && unitList !== undefined) {
                setAutoUnitFilteredValue([...unitList]);
            } else {
                setAutoUnitFilteredValue(
                    unitList?.filter((unit) => {
                        return unit?.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };


    const searchCategory = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && categoryList !== undefined) {
                setAutoCategoryFilteredValue([...categoryList]);
            } else {
                setAutoCategoryFilteredValue(
                    categoryList.filter((category) => {
                        return category?.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchBrand = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && brandList !== undefined) {
                setAutoBrandFilteredValue([...brandList]);
            } else {
                setAutoBrandFilteredValue(
                    brandList?.filter((brand) => {
                        return brand.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchVendorName = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && vendorNameList !== undefined) {
                setAutoVendorNameFilteredValue([...vendorNameList]);
            } else {
                setAutoVendorNameFilteredValue(
                    vendorNameList?.filter((vendor) => {
                        return vendor.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchCPU = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && cpuList !== undefined) {
                setAutoCPUFilteredValue([...cpuList]);
            } else {
                setAutoCPUFilteredValue(
                    cpuList?.filter((cpu) => {
                        return cpu?.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchGen = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && genList !== undefined) {
                setAutoGenFilteredValue([...genList]);
            } else {
                setAutoGenFilteredValue(
                    genList?.filter((gen) => {
                        return gen?.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchMemory = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && memoryList !== undefined) {
                setAutoMemoryFilteredValue([...memoryList]);
            } else {
                setAutoMemoryFilteredValue(
                    memoryList?.filter((memory) => {
                        return memory.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchHDD = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && hddList !== undefined) {
                setAutoHDDFilteredValue([...hddList]);
            } else {
                setAutoHDDFilteredValue(
                    hddList?.filter((hdd) => {
                        return hdd.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchSSD = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && ssdList !== undefined) {
                setAutoSSDFilteredValue([...ssdList]);
            } else {
                setAutoSSDFilteredValue(
                    ssdList?.filter((ssd) => {
                        return ssd.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchColor = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && colorList !== undefined) {
                setAutoColorFilteredValue([...colorList]);
            } else {
                setAutoColorFilteredValue(
                    colorList?.filter((color) => {
                        return color.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchGPU = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && gpuList !== undefined) {
                setAutoGPUFilteredValue([...gpuList]);
            } else {
                setAutoGPUFilteredValue(
                    gpuList?.filter((gpu) => {
                        return gpu.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchDisplay = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && displayList !== undefined) {
                setAutoDisplayFilteredValue([...displayList]);
            } else {
                setAutoDisplayFilteredValue(
                    displayList?.filter((display) => {
                        return display.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    // columns of the table with header name

    const tableColumns = [
        { field: "unit_name", header: "Unit", sortableBody: NameColumn },
        { field: "serial_no", header: "Serial No", sortableBody: NameColumn },
        { field: "model_no", header: "Model No", sortableBody: NameColumn },
        { field: "category_name", header: "Category", sortableBody: NameColumn },
        { field: "brand_name", header: "Brand", sortableBody: NameColumn },
        { field: "vendor_name", header: "Vendor", sortableBody: TextColumn },
        { field: "purchase_date", header: "Purchase Date", sortableBody: TextColumn },
        { field: "purchase_cost", header: "Purchase Cost", sortableBody: TextColumn },
        { field: "is_maintenance", header: "Is Maintenance?", sortableBody: TextColumn },
        { field: "is_warranty", header: "Is Warranty?", sortableBody: TextColumn },
        { field: "is_archived", header: "Is Archived?", sortableBody: TextColumn },
        { field: "warranty_date_from", header: "warranty date from", sortableBody: TextColumn },
        { field: "warranty_date_till", header: "Warranty date till", sortableBody: TextColumn },
        { field: "last_assign_user", header: "Assign user", sortableBody: TextColumn },
        { field: "description", header: "Description", sortableBody: TextColumn },
        { field: "cpu", header: "CPU", sortableBody: TextColumn },
        { field: "gen", header: "GEN", sortableBody: TextColumn },
        { field: "memory", header: "Memory", sortableBody: TextColumn },
        { field: "hdd", header: "HDD", sortableBody: TextColumn },
        { field: "ssd", header: "SSD", sortableBody: TextColumn },
        { field: "color", header: "Color", sortableBody: TextColumn },
        { field: "gpu", header: "GPU", sortableBody: TextColumn },
        { field: "display", header: "Display", sortableBody: TextColumn },
    ];

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "start_purchase_date",
            name: "start_purchase_date",
            value: "start_purchase_date",
            type: "date",
            labelFor: "start_purchase_date",
            label: "Purchase date from",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
        },
        {
            id: "end_purchase_date",
            name: "end_purchase_date",
            value: "end_purchase_date",
            type: "date",
            labelFor: "end_purchase_date",
            label: "Purchase date till",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
        },
        {
            id: "unit",
            name: "unit",
            type: "select",
            labelFor: "unit",
            label: "Select Unit",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoUnitFilteredValue,
            autoCompleteMethod: searchUnit,
            selectedAutoValue: unitList,
        },
        {
            id: "category",
            name: "category",
            type: "select",
            labelFor: "category",
            label: "Select Category",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoCategoryFilteredValue,
            autoCompleteMethod: searchCategory,
            selectedAutoValue: categoryList,
        },
        {
            id: "brand",
            name: "brand",
            type: "select",
            labelFor: "brand",
            label: "Select Brand",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoBrandFilteredValue,
            autoCompleteMethod: searchBrand,
            selectedAutoValue: brandList,
        },
        {
            id: "vendor",
            name: "vendor",
            type: "select",
            labelFor: "vendor",
            label: "Select Vendor",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoVendorNameFilteredValue,
            autoCompleteMethod: searchVendorName,
            selectedAutoValue: vendorNameList,
        },
    ];

    const extraInputs = [
        {
            id: "cpu",
            name: "cpu",
            type: "select",
            labelFor: "cpu",
            label: "Select CPU",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoCPUFilteredValue,
            autoCompleteMethod: searchCPU,
            selectedAutoValue: cpuList,
        },
        {
            id: "gen",
            name: "gen",
            type: "select",
            labelFor: "gen",
            label: "Select Gen",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoGenFilteredValue,
            autoCompleteMethod: searchGen,
            selectedAutoValue: genList,
        },
        {
            id: "memory",
            name: "memory",
            type: "select",
            labelFor: "memory",
            label: "Select Memory",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoMemoryFilteredValue,
            autoCompleteMethod: searchMemory,
            selectedAutoValue: memoryList,
        },
        {
            id: "hdd",
            name: "hdd",
            type: "select",
            labelFor: "hdd",
            label: "Select HDD",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoHDDFilteredValue,
            autoCompleteMethod: searchHDD,
            selectedAutoValue: hddList,
        },
        {
            id: "ssd",
            name: "ssd",
            type: "select",
            labelFor: "ssd",
            label: "Select SSD",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoSSDFilteredValue,
            autoCompleteMethod: searchSSD,
            selectedAutoValue: ssdList,
        },
        {
            id: "color",
            name: "color",
            type: "select",
            labelFor: "color",
            label: "Select Color",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoColorFilteredValue,
            autoCompleteMethod: searchColor,
            selectedAutoValue: colorList,
        },
        {
            id: "gpu",
            name: "gpu",
            type: "select",
            labelFor: "gpu",
            label: "Select GPU",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoGPUFilteredValue,
            autoCompleteMethod: searchGPU,
            selectedAutoValue: gpuList,
        },
        {
            id: "display",
            name: "display",
            type: "select",
            labelFor: "display",
            label: "Select Display",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoDisplayFilteredValue,
            autoCompleteMethod: searchDisplay,
            selectedAutoValue: displayList,
        },
    ];

    return (
        <>
            <form onSubmit={formik.handleSubmit} ref={ref} className={`grid mt-2`}>
                
                {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                        
                    <div key={id} className={`p-field ${className}`} >
                        <InputField
                            id={id}
                            type={type}
                            required={required}
                            name={name}
                            errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                            label={label}
                            labelFor={labelFor}
                            rows={rows}
                            value={formik.values[name]}
                            autoCompleteMethod={autoCompleteMethod}
                            autoFilteredValue={autoFilteredValue}
                            onChange={(...args) => {
                                !onChange && formik.handleChange(...args);
                                onChange?.(...args);
                            }}
                            onBlur={onBlur}
                            onClose={() => formik.setErrors({})}
                            {...rest}
                        />
                    </div>
                ))}
                <>
                    {
                        (formik?.values?.category?.['name'] == "Laptop" || formik?.values?.category?.['name'] == "Desktop" || formik?.values?.category?.['name'] == "Tablet" || formik?.values?.category?.['name'] == "Monitor") ? <>
                            {extraInputs.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                                <div key={id} className={`p-field ${className}`} >
                                    <InputField
                                        id={id}
                                        type={type}
                                        required={required}
                                        name={name}
                                        errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                        label={label}
                                        labelFor={labelFor}
                                        rows={rows}
                                        value={formik.values[name]}
                                        autoCompleteMethod={autoCompleteMethod}
                                        autoFilteredValue={autoFilteredValue}
                                        onChange={(...args) => {
                                            !onChange && formik.handleChange(...args);
                                            onChange?.(...args);
                                        }}
                                        onBlur={onBlur}
                                        onClose={() => formik.setErrors({})}
                                        {...rest}
                                    />
                                </div>
                            ))}
                        </> : <></>
                    }
                </>
                <div className={`p-field col-12 md:col-3`} >
                    <Button 
                        type='submit'
                        label={ reportListLoading ? 'Data are Loading. Please wait!' : 'Search'}
                        loading={reportListLoading}
                        style={{'width': "100%"}}
                        icon={<FiSearch className="text-3xl mr-2" />}
                    />
                <span >Note: If you use <span style={{fontWeight: 'bold', color: '#FFAC1C'}}>Purchase date</span> filter, Null / Emtpy purchase date assets will exclude !</span>
                </div>
                
            </form>
            
            <Table
                //data
                tableHeaderName="Reports"
                tableColumns={tableColumns}
                data={reportList}
                loading={reportListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                toolbarPermissions={permissionList[0]}
                exportBtn
                hideLeftToolbar
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                // actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
        </>
    );
};

export default Report;
